import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { userGroupApi } from '~/apis/userGroupApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { useCheckRole } from '~/hooks/useCheckRole'
import { ApplicationRoutes } from '~/types/RoutingTypes'
import { getUserRoleClassification } from '~/utils/auth'

import { UserGroupList } from '@mangovoice/user-groups-ui'

export const UserGroupsPage = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })

  const checkRole = useCheckRole()
  // Two-tier model matching legacy + backend permissions:
  //   - Mango staff / superusers can manage groups AND edit access fields.
  //   - Customer Super Admins can manage groups, but the form hides the
  //     nine *_access fields (see UserGroupAdd/EditPage).
  // `checkRole('super')` alone excludes Mango staff whose admin level is
  // classified as 'senior' (e.g. role "mango" / "internal administrator"),
  // so we widen the check to include them here.
  const { isMangoStaff, isSuperuser } = getUserRoleClassification(userRoles)
  const canManage = isMangoStaff || isSuperuser || checkRole('super')

  if (!pbxId) {
    return null
  }

  return (
    <UserGroupList
      api={userGroupApi}
      pbxId={pbxId}
      onNavigateToEdit={(groupId: number) => {
        navigate(
          ApplicationRoutes.USER_GROUP_EDIT.replace(
            ':userGroupId',
            String(groupId),
          ),
        )
      }}
      onNavigateToAdd={() => navigate(ApplicationRoutes.USER_GROUP_ADD)}
      canCreate={canManage}
      canEdit={canManage}
      canDelete={canManage}
      toast={toaster}
      t={t}
      locale={i18n.language}
    />
  )
}
